import { CircleImage } from '@common/components/circle_images';

export const FOODS: CircleImage[] = [
  {
    name: 'えらべる！肉盛りプレートスペシャル',
    price: 2300,
    path: 'https://lh3.googleusercontent.com/pw/ABLVV85Uld8aQpORLNqYYOQWwfKq2syHfkAQpQBZEMnDOTeG4rkwzqPJuw5Sw12IifatqAk9ZZ4YSWDUirm-OcNg-ujbJVX3mzwBQhFgwuwp37gqSriocjXX8LygkJiKUUZIFd91TQnn7M1O6KwuO7dlWMBL=w480-h480-s-no-gm?authuser=0',
    descriptions: [
      'お好きな肉料理が楽しめる【選べる肉盛りプレート】の登場！',
      '肉料理を3種類以上選んで下さい☆',
      '最大6種類まで楽しめます！！',
      '',
      '※ お選びいただいた肉料理により価格は異なります (2,300円〜)',
    ],
  },
  {
    name: '厚切りベーコン',
    price: 1200,
    path: 'https://lh3.googleusercontent.com/pw/ABLVV86hCQllIJn-FG7sYuv2l6sZfSD9PgOa1ayU4eQ6SrJMYEwsBKkUm4nT5ENZKRYRbKF6WQxbLjp_8CcTXap4mmsIul0KdC0sPw5hCzqFWtL8lY2VzCnnUUTeynuBbrE26ripCSU05TLip4INsoVXOEjg=w480-h480-s-no-gm?authuser=0',
    descriptions: [
      'ボリューム満点！',
      '燻製ベーコンのスモーキーさでビールが進みます！',
    ],
  },
  {
    name: '極太ソーセージ2本',
    price: 1200,
    path: 'https://lh3.googleusercontent.com/pw/ABLVV84cW0BtrGe2GzYqTCd4txwu30GMTXDKhv4mcaN7QknGkLCNnaqyiOTMdK-wdQBfrxhpGQ_tU2ea3Y-QKdYHOAtkXd2MFW87sW_1PRjQ70NvSeEAF9_7vgdwDdRR5hrmGIG7C29Q4JLAZ7Lur1t4yB3r=w480-h480-s-no-gm?authuser=0',
    descriptions: ['肉汁が溢れ出す大きな生ソーセージをじっくり焼き上げます！'],
  },
  {
    name: '牛ハラミステーキ',
    price: 1200,
    path: 'https://lh3.googleusercontent.com/pw/ABLVV866FbSHr_8rKQqVT5HeT4iWXXZqL1fEJaReGqC5x4hpDfaJyiahW6pESUIQShcibd9GtTMwnYDm_cH9KiI_erBMhqEW4DkWo_UrP1MAvUoyXTz4aBgcdW6RCFANH-paqN_tKYERR2OKurqobwwxlpQq=w480-h480-s-no-gm?authuser=0',
    descriptions: ['柔らかくジューシーで、特製オニオンソースと良く合います！'],
  },
  {
    name: 'A4黒毛和牛ステーキ',
    price: 1800,
    path: 'https://lh3.googleusercontent.com/pw/AP1GczO_ylVoYreD2Gaeam2fJ_6siO88QJ6xkhFOY7oMf7BmCrv40cqFQNpVb1xY5ZE80oZZ5-fj2SEYgv2ktA4NrWQezLESQ5yjJlPtl_-C11u79aC8i1aOqZQCg-PmT-xejjmqZyJVg6Fyl6GZScLQgoWK=w150-h150-s-no-gm?authuser=0',
    descriptions: [
      'A4ランク上質な霜降りもも肉をレアで焼き上げます！',
      '黒毛和牛の旨味が飛び出し極上の味わいを堪能できます',
      'お肉好きにはたまらない逸品！',
      '☆オススメはガーリックバター醤油で',
    ],
  },
  {
    name: '自家製ローストビーフ',
    price: 500,
    path: 'https://lh3.googleusercontent.com/pw/ABLVV86mhUNjSmFGHYNCwftDU3EbPuuLNvRlYA6CMyjQaU8GJQX6Co9jQHRIRCDIlib150_FKzPxKKwzD3TEuen263RlWxQ6olE8lH3yHzBCfQcLtkbuLVatIZaz6H0RTcOq5EDlXDQ97oP8Df7tciEZ9c-0=w1536-h1536-s-no-gm?authuser=0',
    descriptions: ['月曜日～木曜日限定メニュー！', '限定１０皿になります！'],
  },
  {
    name: 'フリッタータ',
    price: 500,
    path: 'https://lh3.googleusercontent.com/pw/ABLVV84hqj5XHU1OsOmIjXcwAMwPxyzQ1Eu96U940E28ywEZpnM2P-ztyUGB7MxrYceQqfxsCfuLsFQ60eewAnGIBXbSj8V9ClFQJ2WPo6zqL7gmb3y539etyObISxlQ9znf7o2xBhd-hZ1GN-LmZX-6ErZI=w1536-h1536-s-no-gm?authuser=0',
    descriptions: ['冷製オムレツです！'],
  },
  {
    name: '自家製ピクルス',
    price: 500,
    path: 'https://lh3.googleusercontent.com/pw/ADCreHfhRlZfoPsXvUagrqn_7x22qGS8dAH0hZes42XzsRjaFl4CMbsWLvRll0Gg_hnDlj_6_beMlwhtqMLEZsjrldOBsadn2JwXBw2RdB8I3l5P18TlQ4qnmwfsNoFIovMH9fDw_g2tD9swrBKfsI5kz_ac=w1280-h1280-s-no?authuser=0',
    descriptions: ['旬なお野菜をハーブ＆スパイスで美味しく漬け込みました'],
  },
  {
    name: 'ドライフルーツ',
    price: 600,
    path: 'https://lh3.googleusercontent.com/pw/ADCreHf5NzCbxJggAmvBpM9GpCjOR3-BXp1YBeQCjcP6e7a8_x4z0bvYpRmM6im4CsrtXqZvMKelgmBtwlnpbNp8JI3gs5Z5AFUKifz9UKm8ge8JIVPxkhj5p4CH0ymnv3qJKrW5gXCDxVWODPCxTxKcNul_=w1280-h1280-s-no?authuser=0',
    descriptions: [
      '大粒レーズン、クランベリー、マンゴー、ジンジャー盛り合わせ',
    ],
  },
  {
    name: 'イカと旬野菜のジェノベーゼ',
    price: 500,
    path: 'https://lh3.googleusercontent.com/pw/ADCreHe2t1jTU0C0_ZOODzyv-SGwcyb6Wvw-o5ETV22LvhwOFQNxH0qW3oiQgKcXHK8VtXHa-ELFibOS_f_V3O8K8EfELKRtypoZ4s50Yf4VnBiwUqlKyln3UqnJ9NEazDueKZvpiGPce18bxragqaaTm3Ar=w1280-h1280-s-no?authuser=0',
    descriptions: ['バジルソースが決め手'],
  },
  {
    name: 'オリーブ盛り',
    price: 500,
    path: 'https://lh3.googleusercontent.com/pw/ADCreHfUbnaplUT2lnY0nlu8StpiRHYjw31O8LYbmjdUjL4ZEJKPRW-tp8glGFwCS_ZsLtA-aQewfVppgTp3B9TJChAqLg6-E6C5bWCHVg3GxDaXI6H6gWkerFvFiA9OLohvyt2BbcIZ-0MPruxbOdvx9sZF=w1280-h1280-s-no?authuser=0',
    descriptions: [
      'アンチョビやパプリカペーストが詰まっているおつまみオリーブ',
    ],
  },
  {
    name: 'ミックスナッツ',
    price: 500,
    path: 'https://lh3.googleusercontent.com/pw/ADCreHfyTs_YYuAXotImodeOwypJgWT9BvUI9W3WWlVFa1hepu-fbMIgEghA5BWc6A-hHtvbSCnDKSQiTT6rGn_Wx2naXjx023lxeS0KZ0kqES_GIcEorP3zxMu05BZMaAJQN1H0WevEPKOrBAhks9_O_cId=w1280-h1280-s-no?authuser=0',
    descriptions: ['Bar定番のおつまみ！', 'お口がさみしい時はこれ!'],
  },
  {
    name: 'シーザーサラダ ～フリーラ風～',
    price: 1000,
    path: 'https://lh3.googleusercontent.com/pw/ADCreHdvD9hBXmBzYjWUfgz-0FVmUFb24xp6Xxy51pz9uwsI9ESyvSwBsA_uNKxa8wwDPZzAGQsUc9ihLz6b25Cc57qenaDGHcF4S0zI3Fbn123yx1ILOinmHsTUczVDiTBsgQ7RpDL0VL7TpTvczi5bVflb=w1280-h1280-s-no?authuser=0',
    descriptions: [
      'フレッシュな野菜と半熟卵が入ったオリジナルのシーザーサラダ',
    ],
  },
  {
    name: '具材盛りだくさん 彩野菜のコブサラダ',
    price: 1100,
    path: 'https://lh3.googleusercontent.com/pw/ADCreHcFB_KJLcGy9QgdRTzidUpuDsRtVSbtMAzWLpYhfYRPXmGZLi0kD1l38WDSuPfOF2JlkzjTtfogtD05PP8ts68GyxFLiJmKigMtLs3gAUodHNrxlLE9yAW3Vg3omj98vhJiqR_k1u9RhUeoDMzyAnHJ=w1280-h1280-s-no?authuser=0',
    descriptions: ['10種類以上の旬な野菜がゴロゴロ入ったスペシャルサラダ!'],
  },
  {
    name: 'フィッシュ&チップス ハーフサイズ (1~2人前)',
    price: 950,
    path: 'https://lh3.googleusercontent.com/pw/ADCreHfyVQTF4TeDIvlSW7dUL0_pNW6lcawIjXfj0LIZoR5gHOX0f9Sak0NLKx72V2OwrM88lA0U6Oe9szLWwRPROjWYxrlrXPhIhxqt_4PDnuoWBhTXD7GvPPu-yfq30axflHjCzDN6fA8-8Gikdfo-Vfjp=w1280-h1280-s-no?authuser=0',
    descriptions: ['当店1番人気メニュー！', '麦酒にはこれ！'],
  },
  {
    name: 'フィッシュ&チップス フルサイズ (3~4人前)',
    price: 1800,
    path: 'https://lh3.googleusercontent.com/pw/ADCreHdGkc5u4ENyN2HuVVbgFWnXGLSDnHcDpvsgsQefGp2MZ3owZO9H2PUEQo19GqKMG9ds0MF803a_ZPJ40Xf3vsIw6tjEKswvihbWRV7wDH3KjTFfRV0W5gOUUAZm9cnD5FYA6QYNqECDLE3ZdOjTadY1=w1280-h1280-s-no?authuser=0',
    descriptions: ['当店1番人気メニュー！', 'ボリューム満点！'],
  },
  {
    name: 'スパイシーフライドポテト',
    price: 650,
    path: 'https://lh3.googleusercontent.com/pw/ADCreHfQ3qk-PUd4qmrCSgzAFcBqbfoqakQJM0AqzWeNuZwwTNhWlwByzCH4NhLzTeHzgKAA8A475LCQWHNcnCIidxPKMWJYrEP4zhS-Qap9SFETt_2BdmthtPOE78wulaj5AIKU6o_XO2Pt4-cnDWYDXgIY=w1280-h1280-s-no?authuser=0',
    descriptions: ['スパイス香るやみつきポテト！'],
  },
  {
    name: 'チーズがけスパイシーフライドポテト',
    price: 850,
    path: 'https://lh3.googleusercontent.com/pw/ADCreHd-zuiSnYovcxFhriGO9YP-1RiF4rsy9EqaMwWQ3Z0nSlJ66v51tAaQ0Y9BTv8yqq0isQZlRLKEtNTRCwbZdezfuk6Pn6ruJbLJU1RRuC3SUcOuhGd6N31-6QPOTqZt_l47C1nM75xKkUIJz6Uzcvsa=w1280-h1280-s-no?authuser=0',
    descriptions: ['すりおろしたふわふわチーズをたっぷりと!'],
  },
  {
    name: 'アンチョビポテト',
    price: 750,
    path: 'https://lh3.googleusercontent.com/pw/ADCreHc9TVK8Oz_syfilLXIoSuYb2Xcq4DACyZ8csQa11UI2CQ3IaQJcBUw7AqYA1w5n4jyki-QjacseeLxS1_HRL8fONsqtLFC4p5Sh7CqM-5sgmCZ4Wfm-TGZ094A8yt45fYbZpRwqeyHGlyxV-RT6xN4I=w640-h640-s-no?authuser=0',
    descriptions: [
      'イタリアシチリア島産のアンチョビで自家製ソースを手作り！',
      'テッパンメニュー！!',
    ],
  },
  {
    name: 'ケイジャンフライドチキン',
    price: 400,
    path: 'https://lh3.googleusercontent.com/pw/ADCreHde3ADG0t24hIhu02tnZiwKjb6ugMXYGV3kPu2_Y-JkYTwIDOroPfMvnJD78Zyr8dfN52JtXolIiWBT_BCBiK_7znpfX6425bhr-HDUmWttY1CxEE0_KVVzHBN5fNlUbWcs_LZBhKfiJjkG9I3IAk7K=w640-h640-s-no?authuser=0',
    descriptions: [
      'ビール&ブレンドスパイスに漬け込んで鶏もも肉を2度揚げでしっとりと！',
      '',
      '2個 400円',
      '4個 800円',
      '6個 1,200円',
    ],
  },
  {
    name: 'チーズケーキブリュレ',
    price: 600,
    path: 'https://lh3.googleusercontent.com/pw/ABLVV85SM7AfBN-GQ67SuDkE_0Pl2ioOQZlUPEt2WpLaZVyVh_WnNu-V0_XH1SJIY5BrAbb932TZj0OpQUD63y68dz5Q3pIXM3WVU8S6UWEb0h5k2lfSD9GsKk0BZsT5BQrcAyr0W1i5EQ-074N4hvyx609F=w480-h480-s-no-gm?authuser=0',
    descriptions: [
      'チーズケーキをブリュレに！',
      'ベリーソースで仕上げました！',
    ],
  },
];
